import { Component, KeyValueDiffers, ViewChild, Input, Output, HostListener, EventEmitter, Directive, ElementRef, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxImageSwiperComponent = /** @class */ (function () {
    function NgxImageSwiperComponent(differs) {
        this.differs = differs;
        this.swiperConfig = {
            navigation: true,
            navigationPlacement: "outside",
            navigationLeftIcon: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDVweCIgaGVpZ2h0PSI0NXB4IiB2aWV3Qm94PSIwIDAgNDUgNDUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjIgKDQ3MzI3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5sZWZ0LWFycm93PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9ImxlZnQtYXJyb3ciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIyLjUwMDAwMCwgMjIuNTAwMDAwKSByb3RhdGUoMTgwLjAwMDAwMCkgdHJhbnNsYXRlKC0yMi41MDAwMDAsIC0yMi41MDAwMDApIHRyYW5zbGF0ZSgxLjAwMDAwMCwgMS4wMDAwMDApIj4KICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbCIgc3Ryb2tlPSIjRjFGMUYxIiBmaWxsPSIjRjFGMUYxIiBjeD0iMjEuNSIgY3k9IjIxLjUiIHI9IjIxLjUiPjwvY2lyY2xlPgogICAgICAgICAgICA8cGF0aCBkPSJNMTcuNDM2ODgwMywyMC41OTIzMzU4IEwyMy44NzQyOTkzLDE0LjQyMzc4NjEgQzI0LjQ2NDU4NjMsMTMuODU4NzM4IDI1LjQzMDI2NjMsMTMuODU4NzM4IDI2LjAxOTg4MTgsMTQuNDIzNzg2MSBMMjYuNTU3Nzg4NCwxNC45Mzg2MzY0IEMyNy4xNDc0MDM5LDE1LjUwMzA0MSAyNy4xNDc0MDM5LDE2LjQyOTEyNzkgMjYuNTU3Nzg4NCwxNi45OTQxNzYgTDIxLjY0NTQ0NTQsMjEuNzAxODM4MSBMMjYuNTU3Nzg4NCwyNi40MDk1MDAyIEMyNy4xNDc0MDM5LDI2Ljk3NDU0ODMgMjcuMTQ3NDAzOSwyNy45MDA2MzUyIDI2LjU1Nzc4ODQsMjguNDY1MDM5OCBMMjYuMDE5ODgxOCwyOC45Nzk4OTAxIEMyNS40MzAyNjYzLDI5LjU0NTU4MTggMjQuNDY0NTg2MywyOS41NDU1ODE4IDIzLjg3NDI5OTMsMjguOTc5ODkwMSBMMTcuNDM2ODgwMywyMi44MTAwNTMzIEMxNy4xMTk5MTE2LDIyLjUwNzU3ODggMTYuOTc5NTU4OSwyMi4xMDA4NDcxIDE3LjAwMjM5MTQsMjEuNzAxODM4MSBDMTYuOTc5NTU4OSwyMS4zMDI4MjkyIDE3LjExOTkxMTYsMjAuODk2MDk3NCAxNy40MzY4ODAzLDIwLjU5MjMzNTggWiIgaWQ9ImFycm93IiBmaWxsPSIjNTE1MTUxIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIyLjAwMDAwMCwgMjEuNzAyMDc5KSByb3RhdGUoLTE4MC4wMDAwMDApIHRyYW5zbGF0ZSgtMjIuMDAwMDAwLCAtMjEuNzAyMDc5KSAiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==" /* left */,
            navigationRightIcon: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDVweCIgaGVpZ2h0PSI0NXB4IiB2aWV3Qm94PSIwIDAgNDUgNDUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjIgKDQ3MzI3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5yaWdodC1hcnJvdzwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJyaWdodC1hcnJvdyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjIuNTAwMDAwLCAyMi41MDAwMDApIHJvdGF0ZSgxODAuMDAwMDAwKSB0cmFuc2xhdGUoLTIyLjUwMDAwMCwgLTIyLjUwMDAwMCkgdHJhbnNsYXRlKDEuMDAwMDAwLCAxLjAwMDAwMCkiPgogICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBzdHJva2U9IiNGMUYxRjEiIGZpbGw9IiNGMUYxRjEiIGN4PSIyMS41IiBjeT0iMjEuNSIgcj0iMjEuNSI+PC9jaXJjbGU+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNi40MzY4ODAzLDIwLjU5MjMzNTggTDIyLjg3NDI5OTMsMTQuNDIzNzg2MSBDMjMuNDY0NTg2MywxMy44NTg3MzggMjQuNDMwMjY2MywxMy44NTg3MzggMjUuMDE5ODgxOCwxNC40MjM3ODYxIEwyNS41NTc3ODg0LDE0LjkzODYzNjQgQzI2LjE0NzQwMzksMTUuNTAzMDQxIDI2LjE0NzQwMzksMTYuNDI5MTI3OSAyNS41NTc3ODg0LDE2Ljk5NDE3NiBMMjAuNjQ1NDQ1NCwyMS43MDE4MzgxIEwyNS41NTc3ODg0LDI2LjQwOTUwMDIgQzI2LjE0NzQwMzksMjYuOTc0NTQ4MyAyNi4xNDc0MDM5LDI3LjkwMDYzNTIgMjUuNTU3Nzg4NCwyOC40NjUwMzk4IEwyNS4wMTk4ODE4LDI4Ljk3OTg5MDEgQzI0LjQzMDI2NjMsMjkuNTQ1NTgxOCAyMy40NjQ1ODYzLDI5LjU0NTU4MTggMjIuODc0Mjk5MywyOC45Nzk4OTAxIEwxNi40MzY4ODAzLDIyLjgxMDA1MzMgQzE2LjExOTkxMTYsMjIuNTA3NTc4OCAxNS45Nzk1NTg5LDIyLjEwMDg0NzEgMTYuMDAyMzkxNCwyMS43MDE4MzgxIEMxNS45Nzk1NTg5LDIxLjMwMjgyOTIgMTYuMTE5OTExNiwyMC44OTYwOTc0IDE2LjQzNjg4MDMsMjAuNTkyMzM1OCBaIiBpZD0iYXJyb3ciIGZpbGw9IiM1MTUxNTEiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+" /* right */,
            pagination: true,
            paginationPlacement: "outside",
            imgBackgroundSize: "cover",
            border: true,
            borderRadius: 4,
            swipeThreshold: 50,
            loop: true,
            keyboardNavigation: true,
        };
        this.imageClick = new EventEmitter();
        this.currentIndex = 0;
        this.paginationWidth = 0;
        this.differ = this.differs.find({}).create();
    }
    /*====================
    overwrite the config defaults with those from the input if applicable
    and update if/when changes are made
    ====================*/
    /*====================
      overwrite the config defaults with those from the input if applicable
      and update if/when changes are made
      ====================*/
    /**
     * @return {?}
     */
    NgxImageSwiperComponent.prototype.ngDoCheck = /*====================
      overwrite the config defaults with those from the input if applicable
      and update if/when changes are made
      ====================*/
    /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var changes = this.differ.diff(this.config);
        if (changes) {
            for (var configKey in this.config) {
                if (this.config[configKey] != null) {
                    this.swiperConfig[configKey] = this.config[configKey];
                }
            }
        }
    };
    /*====================
    after the template has initialized we need to set the
    widths of the swiper, images and pagination if applicable
    ====================*/
    /*====================
      after the template has initialized we need to set the
      widths of the swiper, images and pagination if applicable
      ====================*/
    /**
     * @return {?}
     */
    NgxImageSwiperComponent.prototype.ngAfterViewInit = /*====================
      after the template has initialized we need to set the
      widths of the swiper, images and pagination if applicable
      ====================*/
    /**
     * @return {?}
     */
    function () {
        this.setSwiperWidths();
    };
    // set the widths of the swipe container and images
    // set the widths of the swipe container and images
    /**
     * @param {?=} currentIndex
     * @return {?}
     */
    NgxImageSwiperComponent.prototype.setSwiperWidths = 
    // set the widths of the swipe container and images
    /**
     * @param {?=} currentIndex
     * @return {?}
     */
    function (currentIndex) {
        var _this = this;
        if (this.images && this.images.length > 0) {
            this.imageSwiperWidth = this.imageSwiper.nativeElement.parentNode.clientWidth;
            this.imageSwiper.nativeElement.style.width = this.imageSwiperWidth * this.images.length + "px";
            this.imageSwiper.nativeElement.classList.remove("smooth");
            this.imageSwiper.nativeElement.style.transform = currentIndex
                ? "translate3d(" + this.currentIndex * -this.imageSwiperWidth + "px, 0, 0)"
                : "translate3d(0, 0, 0)";
            // set the widths of each image based on the parent width
            this.imageSwiper.nativeElement.childNodes.forEach((/**
             * @param {?} node
             * @return {?}
             */
            function (node) {
                if (node.className === "image") {
                    node.style.width = _this.imageSwiperWidth + "px";
                }
            }));
            setTimeout((/**
             * @return {?}
             */
            function () {
                if (_this.swiperConfig.pagination) {
                    _this.paginationWidth = _this.pagination.nativeElement.clientWidth;
                }
            }));
        }
        else {
            console.error("you need to provide some images 🤪");
        }
    };
    /*====================
    we need to check if the window is being resized so that
    we can alter the widths of the swiper and images
    as the resize is happening
    ====================*/
    /*====================
      we need to check if the window is being resized so that
      we can alter the widths of the swiper and images
      as the resize is happening
      ====================*/
    /**
     * @return {?}
     */
    NgxImageSwiperComponent.prototype.windowSizeChange = /*====================
      we need to check if the window is being resized so that
      we can alter the widths of the swiper and images
      as the resize is happening
      ====================*/
    /**
     * @return {?}
     */
    function () {
        this.setSwiperWidths(this.currentIndex);
    };
    /*====================
    go to previous or next image depending on the drag/swipe direction
    only swipe if the threshold has been reached or if the user has
    swiped using a mouse/trackpad and/or has left the containing div
    in which case mouseUpX will be null or undefined
    ====================*/
    /*====================
      go to previous or next image depending on the drag/swipe direction
      only swipe if the threshold has been reached or if the user has
      swiped using a mouse/trackpad and/or has left the containing div
      in which case mouseUpX will be null or undefined
      ====================*/
    /**
     * @param {?} __0
     * @return {?}
     */
    NgxImageSwiperComponent.prototype.goToImage = /*====================
      go to previous or next image depending on the drag/swipe direction
      only swipe if the threshold has been reached or if the user has
      swiped using a mouse/trackpad and/or has left the containing div
      in which case mouseUpX will be null or undefined
      ====================*/
    /**
     * @param {?} __0
     * @return {?}
     */
    function (_a) {
        var direction = _a.direction, mouseUpX = _a.mouseUpX;
        this.imageSwiper.nativeElement.classList.add("smooth");
        this.dragPosition = null;
        /** @type {?} */
        var dragDistance = mouseUpX - this.mouseDownX;
        // next image
        if (direction === "next") {
            if ((mouseUpX && dragDistance < -this.swiperConfig.swipeThreshold) ||
                !mouseUpX) {
                if (this.swiperConfig.loop) {
                    this.currentIndex === this.images.length - 1
                        ? (this.currentIndex = 0)
                        : (this.currentIndex += 1);
                }
                else {
                    this.currentIndex === this.images.length - 1
                        ? (this.currentIndex = this.images.length - 1)
                        : (this.currentIndex += 1);
                }
            }
        }
        // previous image
        if (direction === "previous") {
            if ((mouseUpX && dragDistance > this.swiperConfig.swipeThreshold) ||
                !mouseUpX) {
                if (this.swiperConfig.loop) {
                    this.currentIndex === 0
                        ? (this.currentIndex = this.images.length - 1)
                        : (this.currentIndex -= 1);
                }
                else {
                    this.currentIndex === 0
                        ? (this.currentIndex = 0)
                        : (this.currentIndex -= 1);
                }
            }
        }
        this.setTranslateX();
    };
    /*====================
    if pagination is enabled this is used to control it
    ====================*/
    /*====================
      if pagination is enabled this is used to control it
      ====================*/
    /**
     * @param {?} index
     * @return {?}
     */
    NgxImageSwiperComponent.prototype.goToImageIndex = /*====================
      if pagination is enabled this is used to control it
      ====================*/
    /**
     * @param {?} index
     * @return {?}
     */
    function (index) {
        this.imageSwiper.nativeElement.classList.add("smooth");
        this.currentIndex = index;
        this.setTranslateX();
    };
    /*====================
    calculate the translateX value depending on the currentIndex
    and the imageSwiperWidth so we know which image to show
    ====================*/
    /*====================
      calculate the translateX value depending on the currentIndex
      and the imageSwiperWidth so we know which image to show
      ====================*/
    /**
     * @return {?}
     */
    NgxImageSwiperComponent.prototype.setTranslateX = /*====================
      calculate the translateX value depending on the currentIndex
      and the imageSwiperWidth so we know which image to show
      ====================*/
    /**
     * @return {?}
     */
    function () {
        this.imageSwiper.nativeElement.style.transform = "translate3d(" + this.currentIndex * -this.imageSwiperWidth + "px, 0, 0)";
    };
    /*====================
    mainly for UX purposes we show "drag" the image when the user is dragging
    their cursor/finger over the image to show which way they will swipe
    and also to show the prev/next image
    ====================*/
    /*====================
      mainly for UX purposes we show "drag" the image when the user is dragging
      their cursor/finger over the image to show which way they will swipe
      and also to show the prev/next image
      ====================*/
    /**
     * @param {?} __0
     * @return {?}
     */
    NgxImageSwiperComponent.prototype.mouseDrag = /*====================
      mainly for UX purposes we show "drag" the image when the user is dragging
      their cursor/finger over the image to show which way they will swipe
      and also to show the prev/next image
      ====================*/
    /**
     * @param {?} __0
     * @return {?}
     */
    function (_a) {
        var mouseDownX = _a.mouseDownX, dragX = _a.dragX;
        this.mouseDownX = mouseDownX;
        this.imageSwiper.nativeElement.classList.remove("smooth");
        this.dragPosition = this.currentIndex * -this.imageSwiperWidth + dragX;
        this.imageSwiper.nativeElement.style.transform = "translate3d(" + this.dragPosition + "px, 0, 0)";
    };
    /*====================
    if keyboardNavigation is enabled then listen to keyup events
    on the window and react appropriately if the left or right key is pressed
    ====================*/
    /*====================
      if keyboardNavigation is enabled then listen to keyup events
      on the window and react appropriately if the left or right key is pressed
      ====================*/
    /**
     * @param {?} event
     * @return {?}
     */
    NgxImageSwiperComponent.prototype.onKeyDown = /*====================
      if keyboardNavigation is enabled then listen to keyup events
      on the window and react appropriately if the left or right key is pressed
      ====================*/
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.swiperConfig.keyboardNavigation && event.key === "ArrowLeft") {
            this.goToImage({ direction: "previous", mouseUpX: null });
        }
        if (this.swiperConfig.keyboardNavigation && event.key === "ArrowRight") {
            this.goToImage({ direction: "next", mouseUpX: null });
        }
    };
    /**
     * @param {?} index
     * @return {?}
     */
    NgxImageSwiperComponent.prototype.imageClicked = /**
     * @param {?} index
     * @return {?}
     */
    function (index) {
        this.imageClick.emit(index);
    };
    NgxImageSwiperComponent.decorators = [
        { type: Component, args: [{
                    selector: "ngx-image-swiper",
                    template: "<div class=\"ngx-image-swiper\">\n  <!-- navigation -->\n  <ng-container *ngIf=\"swiperConfig.navigation && images.length > 1\">\n    <div class=\"navigation navigation--left navigation--{{ swiperConfig.navigationPlacement }}\"\n      [ngStyle]=\"{'top': swiperConfig.pagination && swiperConfig.paginationPlacement === 'outside' ? 'calc(50% - 29px)' : '50%'}\">\n      <button class=\"navigation__button navigation__button--left\"\n        (click)=\"goToImage({ direction: 'previous', mouseUpX: null })\"\n        [ngStyle]=\"{ 'background-image': 'url(' + swiperConfig.navigationLeftIcon + ')' }\"\n        [disabled]=\"!swiperConfig.loop && this.currentIndex === 0\">\n      </button>\n    </div>\n    <div class=\"navigation navigation--right navigation--{{ swiperConfig.navigationPlacement }}\"\n      [ngStyle]=\"{'top': swiperConfig.pagination && swiperConfig.paginationPlacement === 'outside' ? 'calc(50% - 29px)' : '50%'}\">\n      <button class=\"navigation__button navigation__button--right\"\n        (click)=\"goToImage({ direction: 'next', mouseUpX: null })\"\n        [ngStyle]=\"{ 'background-image': 'url(' + swiperConfig.navigationRightIcon + ')' }\"\n        [disabled]=\"!swiperConfig.loop && this.currentIndex === images.length - 1\">\n      </button>\n    </div>\n  </ng-container>\n\n  <!-- images -->\n  <div class=\"swipe-container\"\n    [ngStyle]=\"{ 'border-width': swiperConfig.border ? '1px' : '0', 'border-radius': swiperConfig.borderRadius ? swiperConfig.borderRadius + 'px' : '0', 'width': swiperConfig.navigation && swiperConfig.navigationPlacement === 'outside' ? 'calc(100% - 112px)' : '', 'margin': swiperConfig.navigation && swiperConfig.navigationPlacement === 'outside' ? '0 auto' : '' }\">\n    <div #imageSwiper class=\"images-container smooth\" ngxImageSwiper (goToImage)=\"goToImage($event)\"\n      (mouseDrag)=\"mouseDrag($event)\">\n      <div class=\"image\" *ngFor=\"let image of images; let i = index\"\n        [ngStyle]=\"{'background-image': 'url(' + image + ')', 'background-size': swiperConfig.imgBackgroundSize, 'border-radius': swiperConfig.borderRadius ? swiperConfig.borderRadius + 'px' : '0' }\"\n        (click)=\"imageClicked(i)\">\n        <!-- img still here to force the div size -->\n        <img [src]=\"image\">\n      </div>\n    </div>\n  </div>\n\n  <!-- pagination -->\n  <div #pagination *ngIf=\"swiperConfig.pagination && images.length > 1\" class=\"pagination\"\n    [ngClass]=\"{'pagination--inside': swiperConfig.paginationPlacement === 'inside'}\">\n    <button *ngFor=\"let image of images; let i = index\" class=\"pagination__dot\"\n      [ngClass]=\"{'pagination__dot--active': currentIndex === i}\" (click)=\"goToImageIndex(i)\"></button>\n  </div>\n</div>\n",
                    styles: [".ngx-image-swiper{display:flex;position:absolute;top:0;right:0;bottom:0;left:0;flex-direction:column;border-radius:4px}.ngx-image-swiper .swipe-container{box-sizing:border-box;display:flex;flex-direction:column;border-style:solid;border-radius:4px;border-color:rgba(51,51,51,.05);height:100%;overflow:hidden}.ngx-image-swiper .images-container{display:flex;position:relative;height:100%;overflow:hidden}.ngx-image-swiper .images-container.smooth{transition:transform .5s ease-in-out;transition:transform .5s ease-in-out,-webkit-transform .5s ease-in-out}.ngx-image-swiper .image{box-sizing:border-box;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out;background-position:50% 50%;background-repeat:no-repeat;min-width:0;background-color:#f1f1f1}.ngx-image-swiper .image img{visibility:hidden;width:100%;height:100%}.ngx-image-swiper .navigation{display:flex;position:absolute;align-items:center;z-index:1}.ngx-image-swiper .navigation__button{position:relative;transition:opacity .3s ease-in-out;border:0;border-radius:50%;background-position:center;background-repeat:no-repeat;background-size:40px 40px,cover;cursor:pointer;padding:0;width:40px;min-width:auto;height:40px;min-height:auto;margin:0}.ngx-image-swiper .navigation__button img{position:absolute;top:0;right:0;bottom:0;left:0;width:inherit;height:inherit}.ngx-image-swiper .navigation__button:disabled{opacity:.5;cursor:default}.ngx-image-swiper .navigation--inside.navigation--left{left:16px}.ngx-image-swiper .navigation--inside.navigation--right{right:16px}.ngx-image-swiper .navigation--outside.navigation--left{left:0}.ngx-image-swiper .navigation--outside.navigation--right{right:0}.ngx-image-swiper .pagination{display:flex;align-items:center;justify-content:center;margin:16px 0 3px;left:50%;right:50%}.ngx-image-swiper .pagination__dot{margin:0 4px;border:0;border-radius:50%;box-shadow:0 1px 2px rgba(51,51,51,.5);background-color:#f1f1f1;cursor:pointer;padding:0;width:10px;min-width:auto;height:10px;min-height:auto}.ngx-image-swiper .pagination__dot--active{background-color:#333}.ngx-image-swiper .pagination--inside{position:absolute;bottom:0;margin:16px 0}"]
                }] }
    ];
    /** @nocollapse */
    NgxImageSwiperComponent.ctorParameters = function () { return [
        { type: KeyValueDiffers }
    ]; };
    NgxImageSwiperComponent.propDecorators = {
        imageSwiper: [{ type: ViewChild, args: ["imageSwiper", { static: false },] }],
        pagination: [{ type: ViewChild, args: ["pagination", { static: false },] }],
        images: [{ type: Input }],
        config: [{ type: Input }],
        imageClick: [{ type: Output }],
        windowSizeChange: [{ type: HostListener, args: ["window:resize",] }],
        onKeyDown: [{ type: HostListener, args: ["window:keyup", ["$event"],] }]
    };
    return NgxImageSwiperComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxImageSwiperDirective = /** @class */ (function () {
    function NgxImageSwiperDirective(imageSwiper) {
        this.imageSwiper = imageSwiper;
        this.horizontalScroll = false;
        this.goToImage = new EventEmitter();
        this.mouseDrag = new EventEmitter();
    }
    /*====================
    MOUSEDOWN & TOUCHSTART
    the first touch on the image swiper, assume the user is dragging
    the image and record the exact point of the cursor / finger so
    that we know which direction the swipe is
    ====================*/
    /*====================
      MOUSEDOWN & TOUCHSTART
      the first touch on the image swiper, assume the user is dragging
      the image and record the exact point of the cursor / finger so
      that we know which direction the swipe is
      ====================*/
    /**
     * @param {?} event
     * @return {?}
     */
    NgxImageSwiperDirective.prototype.lock = /*====================
      MOUSEDOWN & TOUCHSTART
      the first touch on the image swiper, assume the user is dragging
      the image and record the exact point of the cursor / finger so
      that we know which direction the swipe is
      ====================*/
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.mouseDownX = this.getClientX(event).clientX;
        this.dragging = true;
    };
    /*====================
    MOUSEMOVE & TOUCHMOVE
    the user is dragging the image here so first we get the direction
    and then pass the parent component the parameters it needs to
    calculate thresholds etc.
    ====================*/
    /*====================
      MOUSEMOVE & TOUCHMOVE
      the user is dragging the image here so first we get the direction
      and then pass the parent component the parameters it needs to
      calculate thresholds etc.
      ====================*/
    /**
     * @param {?} event
     * @return {?}
     */
    NgxImageSwiperDirective.prototype.drag = /*====================
      MOUSEMOVE & TOUCHMOVE
      the user is dragging the image here so first we get the direction
      and then pass the parent component the parameters it needs to
      calculate thresholds etc.
      ====================*/
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        event.preventDefault();
        if (this.dragging) {
            this.direction = this.getClientX(event).clientX < this.mouseDownX ? 'next' : 'previous';
            this.mouseDrag.emit({
                mouseDownX: this.mouseDownX,
                dragX: this.getClientX(event).clientX - this.mouseDownX
            });
        }
    };
    /*====================
    MOUSEUP & TOUCHEND
    the user has let go of the image so we tell the parent component
    to swipe left or right depending on the direction we detected earlier
    and we pass the X position for threshold calculations
    ====================*/
    /*====================
      MOUSEUP & TOUCHEND
      the user has let go of the image so we tell the parent component
      to swipe left or right depending on the direction we detected earlier
      and we pass the X position for threshold calculations
      ====================*/
    /**
     * @param {?} event
     * @return {?}
     */
    NgxImageSwiperDirective.prototype.move = /*====================
      MOUSEUP & TOUCHEND
      the user has let go of the image so we tell the parent component
      to swipe left or right depending on the direction we detected earlier
      and we pass the X position for threshold calculations
      ====================*/
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var mouseUpX = event ? this.getClientX(event).clientX : null;
        if (this.dragging) {
            this.goToImage.emit({ direction: this.direction, mouseUpX: mouseUpX });
            this.dragging = false;
            this.mouseDownX = null;
        }
    };
    /*====================
    MOUSEOUT & TOUCHCANCEL/LEAVE
    the user has dragged outside of the swiper containing div
    so we call the move method above to swipe in the direction
    the user was dragging
    ====================*/
    /*====================
      MOUSEOUT & TOUCHCANCEL/LEAVE
      the user has dragged outside of the swiper containing div
      so we call the move method above to swipe in the direction
      the user was dragging
      ====================*/
    /**
     * @return {?}
     */
    NgxImageSwiperDirective.prototype.mouseout = /*====================
      MOUSEOUT & TOUCHCANCEL/LEAVE
      the user has dragged outside of the swiper containing div
      so we call the move method above to swipe in the direction
      the user was dragging
      ====================*/
    /**
     * @return {?}
     */
    function () {
        this.move(null);
    };
    /*====================
    WHEEL
    the user is scrolling left or right with their mouse/trackpad
    we detect this so that we can swipe the images in the direction
    of their swipe as long as they have their cursor over the container
    ====================*/
    /*====================
      WHEEL
      the user is scrolling left or right with their mouse/trackpad
      we detect this so that we can swipe the images in the direction
      of their swipe as long as they have their cursor over the container
      ====================*/
    /**
     * @param {?} event
     * @return {?}
     */
    NgxImageSwiperDirective.prototype.wheel = /*====================
      WHEEL
      the user is scrolling left or right with their mouse/trackpad
      we detect this so that we can swipe the images in the direction
      of their swipe as long as they have their cursor over the container
      ====================*/
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        var _this = this;
        event.preventDefault();
        if (event.wheelDeltaY === 0) {
            // there is an horizontal scroll
            if (!this.horizontalScroll) {
                // goto prev or next image depending on swipe direction
                this.horizontalScroll = true;
                event.wheelDeltaX < 0
                    ? this.goToImage.emit({ direction: 'next', mouseUpX: null }) // left swipe
                    : this.goToImage.emit({ direction: 'previous', mouseUpX: null }); // right swipe
                setTimeout((/**
                 * @return {?}
                 */
                function () {
                    _this.horizontalScroll = false;
                }), 1000);
            }
        }
    };
    /*====================
    we don't know whether the user is using a computer or mobile device
    so we use this method to check for us and grab the correct event
    so that we can get the X position
    ====================*/
    /*====================
      we don't know whether the user is using a computer or mobile device
      so we use this method to check for us and grab the correct event
      so that we can get the X position
      ====================*/
    /**
     * @param {?} event
     * @return {?}
     */
    NgxImageSwiperDirective.prototype.getClientX = /*====================
      we don't know whether the user is using a computer or mobile device
      so we use this method to check for us and grab the correct event
      so that we can get the X position
      ====================*/
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return event.changedTouches ? event.changedTouches[0] : event;
    };
    NgxImageSwiperDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[ngxImageSwiper]'
                },] }
    ];
    /** @nocollapse */
    NgxImageSwiperDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    NgxImageSwiperDirective.propDecorators = {
        goToImage: [{ type: Output }],
        mouseDrag: [{ type: Output }],
        lock: [{ type: HostListener, args: ['mousedown', ['$event'],] }, { type: HostListener, args: ['touchstart', ['$event'],] }],
        drag: [{ type: HostListener, args: ['mousemove', ['$event'],] }, { type: HostListener, args: ['touchmove', ['$event'],] }],
        move: [{ type: HostListener, args: ['mouseup', ['$event'],] }, { type: HostListener, args: ['touchend', ['$event'],] }],
        mouseout: [{ type: HostListener, args: ['mouseout',] }, { type: HostListener, args: ['touchcancel',] }, { type: HostListener, args: ['touchleave',] }],
        wheel: [{ type: HostListener, args: ['wheel', ['$event'],] }]
    };
    return NgxImageSwiperDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxImageSwiperModule = /** @class */ (function () {
    function NgxImageSwiperModule() {
    }
    NgxImageSwiperModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [NgxImageSwiperComponent, NgxImageSwiperDirective],
                    imports: [CommonModule],
                    exports: [NgxImageSwiperComponent, NgxImageSwiperDirective]
                },] }
    ];
    return NgxImageSwiperModule;
}());

export { NgxImageSwiperComponent, NgxImageSwiperModule, NgxImageSwiperDirective as ɵa };
//# sourceMappingURL=ngx-image-swiper.js.map
